import jwt_decode from 'jwt-decode';

export default class LoginForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.username = '';
		this.password = '';
		this.loading = false;
		this.errorMessage = '';
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			const result = await this.app.http.loginUser({
				username:this.username,
				password:this.password
			});

			this.app.validate(!!result.AuthenticationResult, "There was an error signing in. Please try again.");

			let decodedJWT = jwt_decode(result.AuthenticationResult.IdToken);
			//result.AuthenticationResult.userId = decodedJWT.sub;
			// cognito:groups is not really an array. 
			result.AuthenticationResult.isResearcher = Array(...decodedJWT['cognito:groups']).includes('Researchers');
			result.AuthenticationResult.Credentials = result.credentials.Credentials;
			result.AuthenticationResult.IdentityId = result.credentials.IdentityId;

			this.app.localStorage('authentication', result.AuthenticationResult); //AccessToken, ExpiresIn:3600, RefreshToken, TokenType:'Bearer'

			/*
				authentication = {
					"userId": 'ww0a32f-5817-4479-97d3-a75059097f',
					"isResearcher": true,
					"AccessToken": "eyJraWQiOiJlUG1wXC9WMXBoMWRpVFZ2N2VOZWNhSFwvU0doX...",
					"ExpiresIn": 3600,
					"TokenType": "Bearer",
					"RefreshToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIj...",
					"IdToken": "eyJraWQiOiJ2NWFVVWNtdVRDZHRnOTg0VWpzWHVJcVoyOEtxTn...",
					"Credentials": {
						"AccessKeyId": "ASIAIAY75O7MSVER3LW",
						"SecretKey": "bsbupZ1mNbnnzjUOLNiWXQg4RtIeTCm5K4NNLVp",
						"SessionToken": "AgoGb3JpZ2luEHAaCXVzLWVhc3QtMSKAAliNg6GBl...",
						"Expiration": "2018-03-16T13:24:33.000Z"
					},
					"IdentityId": "us-east-1:ac70a32f-5817-4479-97d3-a75059097f34"
				}
			*/

			await this.app.getUser();

			this.reset();
			const nextPage = this.app.user.isResearcher ? '/manage-experiments' : '/experiments';
			this.app.history.push(nextPage);
			this.app.forceUpdate();
			return;
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/LoginForm.js